<template lang="pug">
.c-progress-form__element.c-progress-form__element--grouped.is-highlighted
  label.c-progress-form__title
    | {{$t(`shared.insurances.${tName}`)}}
    Tooltip.p-bubble.p-bubble--inline.p-bubble--small(:content="$t(`shared.insurances.${tName}_tooltip`)")
      Icon(icon="info", classes="p-bubble__icon")
  .c-multiple-choice
    .row.c-multiple-choice__options.text-center
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="own" :name="name" :id="ownId" v-model="question")
        label.c-multiple-choice__label(:for="ownId") Possède
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="own_not" :name="name" :id="ownNotId" v-model="question")
        label.c-multiple-choice__label(:for="ownNotId") Ne possède pas
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="unknown" :name="name" :id="unknownId" v-model="question")
        label.c-multiple-choice__label(:for="unknownId") Ne sais pas
</template>

<script>
import Icon from '../shared/Icon'
import Tooltip from '../shared/Tooltip'

export default {
  components: {
    Icon,
    Tooltip
  },
  props: [
    'risk',
    'risk_object',
    't_key'
  ],
  computed: {
    question: {
      get () {
        // set the property of risk if it does not exist
        if (typeof this.$store.state.belongings[this.risk] === 'undefined') {
          this.$store.state.belongings[this.risk] = {}
        }
        return this.$store.state.belongings[this.risk][this.risk_object]
      },
      set (value) {
        this.$store.commit('updateRiskRiskObject', {risk: this.risk, risk_object: this.risk_object, value: value})
      }
    },
    name () {
      return `${this.risk}_${this.risk_object}`
    },
    tName () {
      return `${this.t_key || this.risk}_${this.risk_object}`
    },
    ownId () {
      return `${this.name}_own`
    },
    ownNotId () {
      return `${this.name}_own_not`
    },
    unknownId () {
      return `${this.name}_unknown`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/Ownership.vue